import { Button as MuiButton } from '@material-ui/core';

export type ButtonProps = {
  children?: JSX.Element | string | JSX.Element[];
  variant?: string;
  color?: string;
  className?: string;
  onClick?: (...args: any[]) => void;
  autoFocus?: boolean;
  disabled?: boolean;
  href?: string;
  startIcon?: JSX.Element;
  target?: string;
  classes?: Record<string, string>;
  type?: 'button' | 'submit' | 'reset';
};

const defaultProps = {
  variant: 'contained',
  color: 'default',
};

/**
 * Default button component for Admin UI.
 *
 * Example:
 *  ```
 *  <Button ButtonProps={{
 *    onClick: () => {
 *      // handle button click
 *    }
 *  }}>Click Me</Button>
 *  ```
 * Wraps material ui button component.
 * @see https://material-ui.com/components/buttons/ for button props options.
 *
 *
 * @param {ButtonProps} props - props passed to mui button
 *
 * @returns {JSX.Element}
 */
export const Button = (props: ButtonProps): JSX.Element => {
  const { children } = props;

  const { variant, color } = { ...defaultProps, ...props };

  return (
    <MuiButton variant={variant as any} color={color as any} {...props}>
      {children}
    </MuiButton>
  );
};
